<div class="modal">
    <header class="header">
        <div class="close-button" (click)="closeModal()">
            <i class="ju ju-close"></i>
        </div>
        <img class="title-icon"
             src="./assets/images/icons/icon-heated-gw.svg"/>
        <span class="title">Gatewayrohdaten</span>
        <div class="refresh"
             fxLayoutAlign="center center"
             (click)="onGatewayRefreshBtnClicked()"
             [ngClass]="{ loading: isLoading, error: hasError }">
            <img src="./assets/images/icons/refresh.svg"/>
        </div>
    </header>

    <div class="modal-content">
        <div class="data-content"
             [ngClass]="{ 'no-valid-data': isLoading || hasError }">
            <div class="card" *ngIf="hasError && !refreshButtonClicked">
                <div class="error">
                    Beim Laden der Daten ist ein Fehler aufgetreten. Bitte klicken Sie
                    zum Wiederholen auf die Schaltfläche „Aktualisieren“.
                </div>
            </div>

            <div class="card" *ngIf="temperatureSensors?.length">
                <div class="card-title">Temperatur</div>
                <div class="card-content">
                    <div class="sensor-row" *ngFor="let sensor of temperatureSensors">
                        <div class="counter">{{ sensor.number | number :'.0-0' }}</div>
                        <div class="label">ID {{ sensor.id }}</div>
                        <div class="value">
                            {{ sensor.value }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="currentLoops?.length">
                <div class="card-title">Pumpen oder Druck</div>
                <div class="card-content">
                    <ng-container
                            *ngFor="let sensor of currentLoops">
                        <div class="sensor-row">
                            <div class="counter">{{ sensor.number }}</div>
                            <div class="label">ID {{ sensor.id }}</div>
                            <div class="value">
                                {{ sensor.value }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <ng-container *ngIf="gatewayRawData?.uvsModule?.length >0">
                <ng-container *ngFor="let module of gatewayRawData.uvsModule">
                    <div class="card"
                         *ngIf="module.moduleInfo.uvsType !== 'OTM01' && module.moduleInfo.uvsType !== 'OTM02' && module.moduleInfo.uvsType !== 'OTM03' && (module.light?.length > 0 || module.leakage?.length > 0 || module.impulse?.length > 0)">
                        <div class="card-title">{{ 'Sonstige - Module ' + module.moduleInfo.address }}</div>
                        <div class="card-content">
                            <div class="sensor-row" *ngIf="module.light?.length > 0">
                                <div class="counter"></div>
                                <div class="label">Licht</div>
                                <div class="value">
                                    {{ module.light[0] }}
                                </div>
                            </div>
                            <div class="sensor-row" *ngIf="module.leakage?.length > 0">
                                <div class="counter"></div>
                                <div class="label">Leckage</div>
                                <div class="value">
                                    {{ module.leakage[0] }}
                                </div>
                            </div>
                            <ng-container *ngIf="module.impulse?.length > 0">
                                <div class="sensor-row" *ngFor="let item of module.impulse, let i = index">
                                    <div class="counter"></div>
                                    <div class="label">{{ 'Impuls Eingang ' + (i + 1) }}</div>
                                    <div class="value">
                                        {{ item }}
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="module.pfc?.length > 0">
                                <div class="sensor-row" *ngFor="let item of module.pfc, let i = index">
                                    <div class="counter"></div>
                                    <div class="label">{{ 'PFC ' + (i + 1) }}</div>
                                    <div class="value">
                                        {{ item }}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <div class="card"
                         *ngIf="(module.moduleInfo.uvsType === 'OTM01' || module.moduleInfo.uvsType === 'OTM02' || module.moduleInfo.uvsType === 'OTM03') && !!module.OTM">
                        <div class="card-title">{{ 'Sonstige - Module ' + (module.moduleInfo.address - 59) }}</div>
                        <div class="card-content">
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Gemessene Temperatur</div>
                                <div class="value">
                                    {{ module.OTM.measTemp }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Simulierte Temperatur</div>
                                <div class="value">
                                    {{ module.OTM.simTemp }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Widerstand Offset</div>
                                <div class="value">
                                    {{ module.OTM.offRes }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Temperatur Offset</div>
                                <div class="value">
                                    {{ module.OTM.offTemp }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Gemessener Widerstand</div>
                                <div class="value">
                                    {{ module.OTM.measRes }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Simulierter Widerstand</div>
                                <div class="value">
                                    {{ module.OTM.simRes }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Zustand</div>
                                <div class="value">
                                    {{ getStateValue(module.OTM.state) }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Modus</div>
                                <div class="value">
                                    {{ module.OTM.mode }}
                                </div>
                            </div>
                            <div class="sensor-row">
                                <div class="counter"></div>
                                <div class="label">Sensor</div>
                                <div class="value">
                                    {{ module.OTM.sensor }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>


            <div class="card" *ngIf="modules?.length">
                <div class="card-content">
                    <ng-container
                            *ngFor="let module of modules">
                        <div class="sensor-row">
                            <div class="counter">{{ module.number }}</div>
                            <div class="label">ID {{ module.id }}</div>
                            <div class="value">
                                {{ module.value }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="popup-footer">
        <button class="primary" (click)="closeModal()">Schließen</button>
    </div>
</div>
